import { render, staticRenderFns } from "./eventSettingPrintComponent.vue?vue&type=template&id=0b2027ba&"
import script from "./eventSettingPrintComponent.vue?vue&type=script&lang=ts&"
export * from "./eventSettingPrintComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports